module.exports = __webpack_public_path__ + "img/Trophy Cup Table15.ebe41baa.jpg";